import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import MainLayout from "@/pages/layouts/MainLayout";
import { ADMIN_ROUTES } from "@/constants";
import { Loader2 } from "lucide-react";

// Lazy load pages
const LoginPage = lazy(() => import("@/pages/LoginPage"));
const DashboardPage = lazy(() => import("@/pages/DashboardPage"));
const UsersPage = lazy(() => import("@/pages/UsersPage"));
const UserDetailPage = lazy(() => import("@/pages/UserDetailPage"));
const AvatarsPage = lazy(() => import("@/pages/AvatarsPage"));
const WordsPage = lazy(() => import("@/pages/WordsPage"));
const GroupsPage = lazy(() => import("@/pages/GroupsPage"));
const WordInsightsPage = lazy(() => import("@/pages/WordInsightsPage"));
const DailyGamePage = lazy(() => import("@/pages/DailyGamePage"));
const SoloGamePage = lazy(() => import("@/pages/SoloGamePage"));
const SoloThreeGamePage = lazy(() => import("@/pages/SoloThreeGamePage"));
const EliminationGamePage = lazy(() => import("@/pages/EliminationGamePage"));
const LeaderboardPage = lazy(() => import("@/pages/LeaderboardPage"));
const NotificationsPage = lazy(() => import("@/pages/NotificationsPage"));

const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
  </div>
);

export const AppRoutes = () => (
  <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route path={ADMIN_ROUTES.LOGIN.link} element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          <Route
            path={ADMIN_ROUTES.DASHBOARD.link}
            element={<DashboardPage />}
          />
          <Route path={ADMIN_ROUTES.USERS.link} element={<UsersPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path={ADMIN_ROUTES.AVATARS.link} element={<AvatarsPage />} />
          <Route path={ADMIN_ROUTES.WORDS.link} element={<WordsPage />} />
          <Route
            path={ADMIN_ROUTES.WORD_INSIGHTS.link}
            element={<WordInsightsPage />}
          />
          <Route path={ADMIN_ROUTES.GROUPS.link} element={<GroupsPage />} />
          <Route
            path={ADMIN_ROUTES.DAILY?.link || "/daily"}
            element={<DailyGamePage />}
          />
          <Route
            path={ADMIN_ROUTES.SOLO?.link || "/solo"}
            element={<SoloGamePage />}
          />
          <Route
            path={ADMIN_ROUTES.SOLO_THREE.link}
            element={<SoloThreeGamePage />}
          />
          <Route
            path={ADMIN_ROUTES.ELIMINATION?.link}
            element={<EliminationGamePage />}
          />
          <Route
            path={ADMIN_ROUTES.LEADERBOARD?.link || "/leaderboard"}
            element={<LeaderboardPage />}
          />
          <Route
            path={ADMIN_ROUTES.NOTIFICATIONS.link}
            element={<NotificationsPage />}
          />
        </Route>
      </Route>
    </Routes>
  </Suspense>
);
